import React from 'react';
import { useInput } from 'hooks';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import './forgotPasswordForm.scss';

const ForgotPasswordForm = ({ forgot }) => {
  const { inputs, handleInputChange } = useInput();

  const FormButton = ({ children, submittedFields }) => (
    <Form.Group controlId="formSubmit">
      <Button variant="occu-primary" type="submit" block>
        {children || 'Submit'}
      </Button>
    </Form.Group>
  );

  return (
    <div className="occu-form occu-form-wide">
      <h4>LET'S FIND YOU</h4>
      <Form
        onSubmit={(event) => {
          forgot(inputs.login);
          event.preventDefault();
        }}
      >
        <Form.Group controlId="formNumber">
          <Form.Label>Username</Form.Label>
          <Form.Control
            type="text"
            name="login"
            onChange={handleInputChange}
            value={inputs.login}
            autoComplete="off"
            required
          />
        </Form.Group>
        <FormButton submittedFields={inputs}>Continue</FormButton>
      </Form>
    </div>
  );
};

export { ForgotPasswordForm };
